export enum CoachingMetric {
  LISTENING = "LISTENING",
  STRUCTURED_HOSTING = "STRUCTURED_HOSTING",
  CLIENT_AGENCY = "CLIENT_AGENCY",
  ENGAGED_INQUIRY = "ENGAGED_INQUIRY",
}

export enum CoachingSection {
  WHAT_YOU_DID_WELL = "WHAT_YOU_DID_WELL",
  WHAT_TO_IMPROVE_NEXT_TIME = "WHAT_TO_IMPROVE_NEXT_TIME",
}

export enum CoachingImportance {
  CRITICAL = "CRITICAL",
  IMPORTANT = "IMPORTANT",
  NOT_APPLICABLE = "NOT_APPLICABLE",
}

export enum CoachingQuoteType {
  CLIENT = "CLIENT",
  ADVISOR = "ADVISOR",
}

export enum CoachingStatus {
  PENDING = "PENDING",
  PROCESSING = "PROCESSING",
  COMPLETED = "COMPLETED",
  ERROR = "ERROR",
}

export interface CoachingQuote {
  id: string;
  text: string;
  quoteType: CoachingQuoteType;
}

export interface CoachingFeedbackItem {
  id: string;
  metric: CoachingMetric;
  section: CoachingSection;
  text: string;
  importance: CoachingImportance;
  quotes?: CoachingQuote[];
  detailedFeedback?: string;
}

export interface AdvisorCoachingResponse {
  id: string;
  conversationid: string;
  averageScore?: number;
  status: CoachingStatus;
  listeningScore?: number;
  structuredHostingScore?: number;
  clientAgencyScore?: number;
  engagedInquiryScore?: number;
  feedbackItems: CoachingFeedbackItem[];
  createdat: number;
  updatedat: number;
}

// Coaching Metrics API Response Types
export interface CoachingMetricsResult {
  id: string;
  conversationId: string;
  userId: string;
  status: CoachingStatus;
  averageScore?: number;
  listeningScore?: number;
  structuredHostingScore?: number;
  clientAgencyScore?: number;
  engagedInquiryScore?: number;
  createdAt: number;
}

export interface CoachingMetricsListResponse {
  data: CoachingMetricsResult[];
  total: number;
  take: number;
  skip: number;
}

// Metric display labels mapping
export const COACHING_METRIC_LABELS: Record<string, string> = {
  listeningScore: "Listening",
  structuredHostingScore: "Structured Hosting",
  clientAgencyScore: "Client Agency",
  engagedInquiryScore: "Engaged Inquiry",
  averageScore: "Average Score",
};

// Chart-friendly data point type
export interface CoachingMetricsDataPoint {
  date: string;
  displayDate: string;
  listeningScore?: number;
  structuredHostingScore?: number;
  clientAgencyScore?: number;
  engagedInquiryScore?: number;
  averageScore?: number;
  userId?: string;
  userName?: string;
}
